import { render } from "./EntryRecord.vue?vue&type=template&id=70fe4224&scoped=true&ts=true"
import script from "./EntryRecord.vue?vue&type=script&lang=ts"
export * from "./EntryRecord.vue?vue&type=script&lang=ts"

import "./EntryRecord.vue?vue&type=style&index=0&id=70fe4224&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fe4224"]])

export default __exports__